import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { shownotice } from "Store";
import { queryGetTemplateList } from "Apollo";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import Icon from "module-common/Icon";
import Row from "./RowWithMutation";

const customPanelStyle = {
  background: "transparent",
  borderRadius: 0,
  marginBottom: 0,
  border: 0,
  overflow: "hidden",
  borderBottom: "1px solid #ddd"
};

export default graphql(queryGetTemplateList)(
  observer(
    class TemplateReplyModal extends Component {
      static propTypes = {
        text: PropTypes.string,
        onCancel: PropTypes.func,
        onConfirm: PropTypes.func
      };
      state = {
        loading: false
      };

      render() {
        const { text, onCancel, onConfirm } = this.props;
        const { loading } = this.state;
        const getTemplateList = this.props.data.getTemplateList;
        const list = getTemplateList ? getTemplateList : [];
        const renders = list.map((row, index) => (
          <Row
            key={row.id}
            id={row.id}
            index={index + 1}
            title={row.content}
            arrOfTemplate={row.templateReply}
            onConfirm={onConfirm}
          />
        ));

        return (
          <Modal>
            <Wrapper>
              <Scrollbars>
                <Text>{text}</Text>
                {renders}
                <XIcon
                  name="x-button-blue"
                  mode="contain"
                  width={30}
                  height={30}
                  onClick={onCancel}
                />
              </Scrollbars>
            </Wrapper>
          </Modal>
        );
      }
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 500px;
`;

const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 20px;
`;

const Buttons = styled.div`
  margin-top: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;

const XIcon = styled(Icon)`
  position: absolute;
  top: 0px;
  right: 0px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/TemplateReplyModal.js